import * as yup from 'yup'

export interface ClosureSchema {
  startDate: string
  startTime: string
  endDate: string
  endTime: string
}

export const closureSchema = yup.object({
  startDate: yup.mixed().required('You must select the Start date of the closure to proceed'),
  startTime: yup.string().required('You must select the Start time of the closure to proceed'),
  endDate: yup.mixed().required('You must select the End date of the closure to proceed'),
  endTime: yup.string().required('You must select the End time of the closure to proceed')
})
